import React, {Component} from 'react';
import Card, {CardContent} from 'material-ui/Card';
import Button from 'material-ui/Button';
import CheckIcon from 'material-ui-icons/Check';
import Input, {InputLabel} from 'material-ui/Input';
import {FormControl, FormHelperText} from 'material-ui/Form';
import PropTypes from 'prop-types';

import "./css/joinFeesie.css";

class JoinFeesie extends Component{


    constructor (props) {
        super(props);
        this.state = {
            feesieIdInput: "000000",
            feesieExists: false, 
          };
    }

    render() {
        return <div className="join-feesie">
        <div className="main-content">
        <Card className="join-feesie-card">
          <CardContent>
            <div className="main-start-form">
              <FormControl className="feesie-id-form" aria-describedby="name-helper-text">
                <InputLabel htmlFor="feesieIdInput">Feesie Code</InputLabel>
                <Input id="feesieIdInput" onChange={this.setFeesieId} type="number" className="feesie-id-input" value={this.state.feesieIdInput}/>
                <FormHelperText id="name-helper-text">Vul de 6-cijferige code in</FormHelperText>
              </FormControl>
            </div>
           
          </CardContent>
        </Card>
        <Button variant="fab" onClick={this.props.joinFeesie} color="white" className="start-fab" aria-label="search">
              <CheckIcon/>
            </Button>
        </div>
        </div>
    }
    
}
JoinFeesie.propTypes = {
  joinFeesie: PropTypes.func,
}
export default JoinFeesie;


// WEBPACK FOOTER //
// ./src/joinFeesie.js